import script from "./DVISummaryWorkOrderPackage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DVISummaryWorkOrderPackage.vue?vue&type=script&lang=ts&setup=true"

import "./DVISummaryWorkOrderPackage.vue?vue&type=style&index=0&id=10ce8274&lang=css"

const __exports__ = script;

export default __exports__